import React from 'react';
import { Typography, Grid, Divider } from '@mui/material';

import { ShsTimeInput } from 'src/components/common';
import { CenterFormFields } from 'src/constants/centers';

interface HospitalWorkingHoursProps {
    getSource: (source: string) => string;
}

export const HospitalWorkingHours: React.FC<HospitalWorkingHoursProps> = ({ getSource }) => {
    return (
        <>
            <Typography variant="h6" component="h6" mb={3} fontWeight="600">
                Робочі години
            </Typography>
            <Grid container sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <Grid sx={{ display: 'flex' }}>
                    <Grid sx={{ display: 'flex', gap: '8px', marginRight: '8px' }}>
                        <ShsTimeInput
                            source={getSource(CenterFormFields.WORK_START)}
                            label="Початок"
                            required
                            isLabelPositionTop
                        />
                        <Divider
                            sx={{
                                width: '7px',
                                borderColor: 'black',
                                borderWidth: '1px',
                                alignSelf: 'center',
                                marginTop: '28px'
                            }}
                        />
                        <ShsTimeInput
                            source={getSource(CenterFormFields.WORK_END)}
                            label="Завершення"
                            required
                            isLabelPositionTop
                        />
                    </Grid>
                    <Grid sx={{ display: 'flex' }}>
                        <Grid sx={{ display: 'flex', gap: '8px', alignItems: 'end' }}>
                            <ShsTimeInput
                                source={getSource(CenterFormFields.BREAK_START)}
                                label="Перерва на обід"
                                required
                                isLabelPositionTop
                            />
                            <Divider
                                sx={{
                                    width: '7px',
                                    borderColor: 'black',
                                    borderWidth: '1px',
                                    alignSelf: 'center',
                                    marginTop: '28px'
                                }}
                            />
                            <ShsTimeInput source={getSource(CenterFormFields.BREAK_END)} required isAsteriskHidden />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};
